import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=7385693f"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7385693f')) {
      api.createRecord('7385693f', component.options)
    } else {
      api.reload('7385693f', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=7385693f", function () {
      api.rerender('7385693f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/supervision-tab/Add.vue"
export default component.exports